import type { Props3 } from "../Types";
import { sanitizeImageUrl } from "../imageUrl";

// Local Tours Card Layout
const CardLayout3 = ({image, title, duration, category, introduction, href = "/"}: Props3) => {

    const introText = (text: string, maxLength: number) => {
        if (!text) return "";
        if (text.length <= maxLength) return text;
        const trimmed = text.substring(0, maxLength);
        const lastWord = trimmed.lastIndexOf(" ");
        return trimmed.substring(0, lastWord) + "...";  
    }

    const shortIntroText = introText(introduction || "", 80);

    return (
    <>
        <div className="card h-100 border-0 shadow-0">
            <a href={href} className="text-dark text-decoration-none d-block h-100">
                <div className="row g-0 h-100">
                    
                    {/* Image */}
                    <div className="col-4 col-md-4 d-flex">
                        <figure className="m-0 w-100 h-100 has-object-fit">
                            <img
                                data-object-fit="cover"
                                className="w-100 h-100 d-block"
                                alt={title}
                                title={title}
                                src={sanitizeImageUrl(image, { width: 400 })}
                            />
                        </figure>
                    </div>

                    {/* Body Content */}
                    <div className="col-8 col-md-8">
                        <div className="card-body py-3">
                            <p className="h6 item-heading text-strong mb-1">{title}</p>
                            <div className="fs-6 text-secondary pb-2">
                                <span className="fs-6">{duration}</span> <br />
                                <span className="badge bg-light text-secondary rounded-pill mt-1">
                                    {category}
                                </span>
                            </div>
                            <p className="mb-0 mt-4">{shortIntroText}</p>
                        </div>
                    </div>

                </div>
            </a>
        </div>
    </>
    )
}

export default CardLayout3
